const pattern = /^\d{3}.\d{3}.\d{3}-\d{2}$/;

export const formCPFPattern = {
  pattern: {
    value: pattern,
    message: 'CPF inválido',
  },
};
